var _defs, _line, _line2, _line3, _polyline, _polyline2, _line4, _line5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCornisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e7f940ad-ef8b-48e4-ab22-2f921e8c846e",
    "data-name": "cornisa",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ba3a63f0-0a4b-4dac-9238-441e22e5a44d,.e9c6967e-16b8-4e56-8cc9-932551a9fdff{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.e9c6967e-16b8-4e56-8cc9-932551a9fdff{stroke-width:8px;}.ba3a63f0-0a4b-4dac-9238-441e22e5a44d{stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cornisa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e9c6967e-16b8-4e56-8cc9-932551a9fdff",
    x1: 4,
    y1: 4,
    x2: 196,
    y2: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "ba3a63f0-0a4b-4dac-9238-441e22e5a44d",
    x1: 31,
    y1: 15,
    x2: 179,
    y2: 15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "ba3a63f0-0a4b-4dac-9238-441e22e5a44d",
    x1: 45,
    y1: 48,
    x2: 45,
    y2: 190
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "e9c6967e-16b8-4e56-8cc9-932551a9fdff",
    points: "162.87 196 162.87 27.73 161.87 27 63.87 27 62.87 27.73 62.87 196"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "e9c6967e-16b8-4e56-8cc9-932551a9fdff",
    points: "4 4 27.02 27.02 27.51 28.49 27.38 196"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "ba3a63f0-0a4b-4dac-9238-441e22e5a44d",
    x1: 40,
    y1: 39,
    x2: 50,
    y2: 39
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "ba3a63f0-0a4b-4dac-9238-441e22e5a44d",
    x1: 38,
    y1: 29,
    x2: 52,
    y2: 29
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornisa);
export default __webpack_public_path__ + "static/media/cornisa.5181ac20f46e3e2a66e991d01abeeab8.svg";
export { ForwardRef as ReactComponent };